import { render, staticRenderFns } from "./VIcon.vue?vue&type=template&id=71d4663a&"
import script from "./VIcon.vue?vue&type=script&lang=ts&"
export * from "./VIcon.vue?vue&type=script&lang=ts&"
import style0 from "./VIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports